import { render, staticRenderFns } from "./payment.vue?vue&type=template&id=081fa232&scoped=true"
import script from "./payment.vue?vue&type=script&lang=js"
export * from "./payment.vue?vue&type=script&lang=js"
import style0 from "./payment.vue?vue&type=style&index=0&id=081fa232&prod&lang=scss"
import style1 from "./payment.vue?vue&type=style&index=1&id=081fa232&prod&lang=scss&scoped=true"
import style2 from "./payment.vue?vue&type=style&index=2&id=081fa232&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081fa232",
  null
  
)

export default component.exports